import React, { useEffect, useRef, useState } from 'react';

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer
      ref={footerRef}
      style={{
        position: 'relative',
        width: '100%',
        background: '#fafafa',
        overflow: 'hidden',
        padding: '0',
        margin: '0',
      }}
    >
      {/* Footer image spanning full width */}
      <img
        src="/assets/footer-wordmark.png"
        alt="demoboy"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'scale(1) translateY(0)' : 'scale(0.98) translateY(30px)',
          transition: 'opacity 1s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s, transform 1s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s',
        }}
      />
    </footer>
  );
};

export default Footer;
